import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import type { SessionController } from "@/lib/session";
import { useI18n } from "@/i18n/I18nProvider";
import { ErrorState } from "@/components/ui/States";

export interface RouterContext {
  queryClient: QueryClient;
  session: SessionController;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
  errorComponent: RootError,
});

function RootLayout() {
  return <Outlet />;
}

function NotFound() {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      <h1 className="page-title">{t("notFound.title")}</h1>
      <p className="page-subtitle">{t("notFound.body")}</p>
      <Link to="/" className="btn btn-primary mt-6 inline-flex">
        {t("notFound.home")}
      </Link>
    </div>
  );
}

function RootError({ error }: { error: unknown }) {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="page-title mb-4">{t("error.pageTitle")}</h1>
      <ErrorState error={error} onRetry={() => window.location.reload()} />
    </div>
  );
}
